import { useMemo } from 'react';
import { useSharedValue } from 'react-native-reanimated';
import { formatAmount } from '../utils';
const usePriceChangeSharedValue = (amount, percent, withAmount) => {
    const amountText = useMemo(() => formatAmount({
        value: Math.abs(amount.value),
        currency: amount.currency,
    }), [amount]);
    const percentText = useMemo(() => `${Math.abs(percent).toFixed(2)}%`, [percent]);
    const priceChangeSharedValue = useSharedValue(withAmount ? `${percentText} (${amountText})` : percentText);
    if (withAmount) {
        priceChangeSharedValue.value = `${percentText} (${amountText})`;
    }
    else {
        priceChangeSharedValue.value = percentText;
    }
    return priceChangeSharedValue;
};
export default usePriceChangeSharedValue;
